import { Component, OnInit } from '@angular/core';
import { environment } from './../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from './shared/services/login/login.service';
import { interval } from 'rxjs';
import { ToastService } from './shared/services/toast/toast.service';
import { Router } from '@angular/router';
import { TitleService } from './shared/services/dynamicTitle/title.service';
import { UserActivitiesService } from './shared/services/user-activities/user-activities.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics/google-analytics.service';
import { APP_CONST } from './shared/constants/app-constants';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  isUserIdle = false;
  currentUrlPath: any = '';
  showModel = false;
  enableDashboard: Boolean = true;
  enableEventPrevention: boolean = false;
  isLoading: boolean = false
  constructor(private googleAnalyticsService: GoogleAnalyticsService, private idleUserService: UserActivitiesService, private _toast: ToastService, private translate: TranslateService, private loginService: LoginService, public router: Router, private titleService: TitleService) {
    this.googleAnalyticsService.initialize();
    this.titleService.titleTracking();
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    console.log(environment.envName);
    if (environment && environment['isDocker'] && environment['isDocker'] == true) {
      const baseElement = document.querySelector('base');
      if (baseElement) {
        baseElement.setAttribute('href', '/v3/');
      }
    }
  }


  title = 'litmusworld_dashboard';
  ngOnInit() {
    // check if internet connectivity available or not
    this.idleUserService.isInternetServiceAvailable.subscribe((isInternetServiceAvailable) => {
      if (isInternetServiceAvailable) {
        this.enableDashboard = true;
        this._toast.showPopup('SUCCESS', '', 'Connection restored. Resuming your session.', 5000)
      } else {
        this.enableDashboard = false;
        this._toast.showPopup('ERROR', '', 'Unable to reach the server. Please check your internet connection and try again.', 5000)
      }
    });
    this.isLoading = true
    this.idleUserService.userInactive.subscribe((isIdle) => {

      this.isUserIdle = isIdle
      let path = this.currentUrlPath;
      path = path.replace('/', '')
      const notIncluseURL = ['login', 'logout', 'forgot-password', 'reset-password', 'message'];
      if (this.currentUrlPath !== null && !notIncluseURL.includes(path) && this.showModel == false) {
        // console.log("User is idle.......", this.currentUrlPath);
        this.loginService.updateLogoutTime().subscribe((response) => {
          // console.log("Is Logged In", response)
          if (response && response['data'] && response['data']['code'] != 0) {
            // console.log("Logged Out")
            this.openModal();
          }
        }, (error) => {
          // This block will only execute if catchError is used
          console.error('Error handler:::::::', error);
          if (error && error['error'] && error['error']['text'] && error['error']['text'] == '402 Not Authorized') {
            this.openModal();
          }
        });
      }

    });
    setTimeout(() => this.isLoading = false, 1500)
  }


  // This function will enable the flag for open user setting pop up
  openModal(): void {
    this.showModel = true;
  }

  // This function will enable the flag for close user setting pop up
  closeModal(): void {
    this.showModel = false;
  }

  loginAgain() {
    this.showModel = false;
    this.router.navigate([APP_CONST.ROUTE_LOGIN])
  }

  useLanguage(language: string) {
    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }
}
